import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Img,
  GridContainer,
  GridRow,
  GridColumn,
  Input,
  Button,
  Loader,
} from "arv-reactcomponents";
import { omniViewimageBasePath } from "../../constants";
import {
  queryParamsToObject,
  objToQueryParams,
  setLastUsedPincode,
} from "../../utils";

class OmniView extends Component {
  static errorForNonStoreCase(type, newArray) {
    let error = "";
    if (type === "today") {
      error =
        newArray.indexOf("today") === -1
          ? "Sorry, no products can be delivered to your pincode today. Showing products that can reach you tomorrow"
          : error;
      error =
        newArray.indexOf("tomorrow") === -1
          ? "Sorry, no products can be delivered to your pincode today. Showing products that can reach you in one week"
          : error;
    } else {
      error =
        newArray.indexOf("tomorrow") === -1
          ? "Sorry, no products can be delivered to your pincode tomorrow. Showing products that can reach you one week"
          : error;
    }
    error =
      newArray.indexOf("one_week") === -1
        ? "Sorry, we currently donot deliver to this pincode"
        : error;
    return error;
  }
  static processResponse(type, data, queryObj) {
    let error = "";
    const newQueryObj = queryObj;
    let value = {};
    if (type === "store") {
      value = {
        mapping: "f-ns",
        key: "nearby_stores",
      };
    } else {
      value = {
        mapping: "f-dt",
        key: "delivery_time",
      };
    }
    const newArray = data[value.key] && data[value.key].map(item => item.value);
    switch (type) {
      case "store":
        error =
          newArray.length === 0
            ? "Sorry, no stores available for the pincode you entered"
            : "";
        break;
      default:
        error = OmniView.errorForNonStoreCase(type, newArray);
        break;
    }
    const newList = newArray.join("--");
    if (newList) {
      newQueryObj[value.mapping] = newList;
    } else {
      delete newQueryObj.r;
      delete newQueryObj["p-st"];
      delete newQueryObj["p-dl"];
    }
    return { error, newQueryObj };
  }
  constructor(props) {
    super(props);
    this.state = {
      pincode: "",
      loading: false,
      text: "",
      showInput: true,
      showtnc: false,
    };
    this.closeOmni = this.closeOmni.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.triggerAction = this.triggerAction.bind(this);
    this.initialize = this.initialize.bind(this);
    this.clickAction = this.clickAction.bind(this);
  }
  componentDidMount() {
    this.initialize();
    const pincodeInput = document.querySelector(".nw-omniviewpincode");
    if (pincodeInput) {
      pincodeInput.focus();
      const val = pincodeInput.value;
      pincodeInput.value = "";
      pincodeInput.value = val;
    }
  }
  initialize() {
    const { type } = this.props;
    let number = 0;
    let text = "";
    switch (type) {
      case "store":
        number = 4;
        text = "See products from stores near you!";
        break;
      case "today":
        number = 1;
        text = "See products that can reach you TODAY!";
        break;
      default:
        number = 2;
        text = "See products that can reach you TOMORROW!";
        break;
    }
    const imagePath = `${omniViewimageBasePath}${number}.png`;
    const showtnc = type !== "store";
    this.setState({
      text,
      type,
      imagePath,
      showtnc,
    });
  }
  closeOmni() {
    this.props.onClose(false);
  }
  clickAction(event) {
    event.preventDefault();
    const { pincode } = this.state;
    if (pincode.length === 6) {
      this.triggerAction(pincode);
    } else {
      this.setState({
        errorMsg: "Please enter a valid pincode",
      });
    }
  }
  inputChange(event) {
    this.errorMsg = null;
    const validatePincode = this.validatePincodedRef.getValidatedOutput(
      event.target.value,
    );
    if (validatePincode.isValid) {
      this.setState({
        pincode: validatePincode.value,
        errorMsg: null,
      });
      if (validatePincode.value.length === 6) {
        this.triggerAction(validatePincode.value);
      }
    } else {
      this.setState({
        errorMsg: validatePincode.errorMsg,
      });
    }
  }
  triggerAction(pincode) {
    this.setState({ loading: true });
    setLastUsedPincode(pincode);
    const { ProductStore } = this.props;
    const { pathname, search } = this.props.location;
    const { type } = this.state;
    const queryObj = queryParamsToObject(search);
    delete queryObj.when;
    queryObj.r = 10;
    queryObj["p-st"] = pincode;
    queryObj["p-dl"] = pincode;
    let newUrl = objToQueryParams(queryObj);
    newUrl = `${pathname}?${newUrl}`;
    ProductStore.getOmniData(newUrl).then(data => {
      const { error, newQueryObj } = OmniView.processResponse(
        type,
        data,
        queryObj,
      );

      newUrl = objToQueryParams(newQueryObj);
      newUrl = `${pathname}?${newUrl}`;
      ProductStore.storeTempUrl(pathname, `?${newUrl}`);
      const newText = error || this.state.text;
      const timeoutVal = error ? 3000 : 0;
      this.setState({ loading: false, text: newText, showInput: !error });
      setTimeout(() => {
        this.props.onClose(newUrl);
      }, timeoutVal);
    });
  }
  render() {
    const { pincode, errorMsg } = this.state;
    return (
      <Modal
        isOpen={this.props.isOpen}
        onClose={this.closeOmni}
        className={`nw-omniview ${this.state.type}`}
      >
        <GridContainer className="nw-omniviewgrid">
          <GridRow className="nw-omniviewimagerow">
            <GridColumn className="nwc-grid-col-sm-8">
              <Img className="nw-omniviewimage" src={this.state.imagePath} />
            </GridColumn>
          </GridRow>
          <GridRow className="nw-omniviewtextcontainer">
            <GridColumn className="nw-omniviewtext">
              {this.state.text}
            </GridColumn>
          </GridRow>
          {this.state.showInput && (
            <GridRow className="nw-omniviewactioncontainer">
              <GridColumn className="nwc-grid-col-sm-6 nw-omniviewactionitems">
                <Input
                  placeholder="Enter your pincode"
                  type="tel"
                  className={`nw-omniviewpincode nwc-inp-sm ${this.type}`}
                  onChange={e => {
                    this.inputChange(e);
                  }}
                  ref={values => {
                    this.validatePincodedRef = values;
                  }}
                  value={pincode}
                  maxLength={6}
                  validateWithPattern={[
                    {
                      pattern: /^((\d+)*)?$/,
                      msg: "Pincode must be a number",
                    },
                  ]}
                />
              </GridColumn>
              <GridColumn className="nwc-grid-col-sm-2 nw-omniviewactionitems">
                {this.state.loading && <Loader />}
                {!this.state.loading && (
                  <Button
                    onClick={this.clickAction}
                    className="nw-omniviewactionbutton"
                  >
                    GO
                  </Button>
                )}
              </GridColumn>
            </GridRow>
          )}
          <GridRow>
            <GridColumn className="nw-omniviewerror">
              <span>{errorMsg}</span>
            </GridColumn>
          </GridRow>
          {this.state.showtnc && (
            <GridRow className="nw-omniviewtnc">
              <GridColumn>
                <span>
                  * available in selected pincodes of Delhi NCR & Bangalore only
                </span>
              </GridColumn>
            </GridRow>
          )}
        </GridContainer>
      </Modal>
    );
  }
}

OmniView.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({}).isRequired,
};
export default OmniView;



// WEBPACK FOOTER //
// ./src/component/OmniView/index.js